import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import * as styles from './Gift.css';
import { IBuyPackageGift } from '../../../../../../../../types';

interface IProps {
  gift: IBuyPackageGift;
}

export const Gift = (props: IProps) => {
  const { name, count } = props.gift;

  return (
    <div className={styles['row']}>
      <UIText2 color="gray60_100">{name}</UIText2>
      <UIText2 color="gray60_100">{count}</UIText2>
    </div>
  );
};
